// retrun keys of values which are numeric (metric keys)
export const getNumValueKeys = (data) => {
  const rowKeys = Object.keys(data).filter((k) => {
    const value = data[k];
    return !isNaN(value) && typeof value === 'number';
  });
  return rowKeys;
};

// calculate max value of each column
// this is used to find the relative share percetage at render time
export const calculatePctShareMax = ({ data, metrics = null }) => {
  const metricValues: any = {};
  const rowKeys = metrics || getNumValueKeys(data[0] || {});

  // max value per column
  data.forEach((row) => {
    rowKeys.forEach((m: any) => {
      if (typeof row[m] === 'number') {
        metricValues[m] = Math.max(row[m], metricValues[m] || 0);
      }
    });
  });

  return metricValues;
};

// UNUSED, will be cleaned up later if max approach is accepted on prod
// calculate total for each row value
// this is used to find the relative share percetage at render time
export const calculatePctShareTotals = ({ data, metrics = null }) => {
  const pctShareTotals: any = {};
  const rowKeys = metrics || getNumValueKeys(data[0] || {});

  data.forEach((row) => {
    rowKeys.forEach((m: any) => {
      if (typeof row[m] === 'number') {
        pctShareTotals[m] = (pctShareTotals[m] || 0) + row[m];
      }
    });
  });

  return pctShareTotals;
};

export const calculatePctShare = ({ value, pctShareMaxValue }) => {
  let pctShare = 0;
  if (!isNaN(value)) {
    pctShare = Math.round((value / pctShareMaxValue) * 100);
  }
  return pctShare;
};
